<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
		name: 'NotFound',
	});
</script>
<!-- @format -->

<template>
	<div class="page-container">
		<div class="img"></div>
		<h1 style="font-weight: 400">页面未找到</h1>
		<el-button type="primary" style="width: 300px" @click="goHome">回到首页</el-button>
	</div>
</template>

<script lang="ts" setup>
	import { getEnvUrlByUrl } from '@power/runtime-vue3';

	//const router = useRouter();
	const goHome = () => {
		//router.push({ path: '/' });
		const url = getEnvUrlByUrl('/');
		if (window.parent === window.self) {
			window.location.href = url;
		} else {
			window.parent.location.href = url;
		}
	};
	;
</script>

<style lang="scss" scoped>
	.page-container {
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		.img {
			background: var(--theme-pc-404-background-image) no-repeat center;
			width: 300px;
			height: 95px;
		}
	}
</style>
